//请求接口列表
const server = {
    base: '/home/base', //基础数据
    home: '/home/index', //首页数据
    product: 'home/product', //产品展示
    product_detail: 'home/product_detail', //产品详情
    news: 'home/news', //新闻中心
    news_detail: 'home/news_detail', //产品详情
    best_news: 'home/best_news', //最新资讯
    about_columns: 'home/menu', //左侧栏目
    detail: 'home/detail', //栏目详情
    create_memo: 'home/create_memo' //在线留言
}
export default server;



// WEBPACK FOOTER //
// ./src/assets/js/servers.js